// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const petilil: PokeData = {
  "id": 548,
  "name": "petilil",
  "height": 5,
  "weight": 66,
  "base_experience": 56,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "recover",
    "giga-drain",
    "charm",
    "synthesis",
    "sunny-day",
    "helping-hand",
    "aromatherapy",
    "magical-leaf",
    "energy-ball",
    "leaf-storm",
    "entrainment",
    "after-you",
    "leafage"
  ],
  "moves": [
    "poison-powder",
    "stun-spore",
    "synthesis",
    "sunny-day",
    "aromatherapy",
    "energy-ball",
    "grassy-terrain",
    "vine-whip",
    "razor-leaf",
    "bullet-seed",
    "power-whip",
    "wood-hammer",
    "flower-rush"
  ],
  "evolution_chain": {
    "id": 279,
    "item": null,
    "species": [
      {
        "name": "petilil",
        "order": 549,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lilligant",
        "order": 550,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 548,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.5,
    "speed": 30,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
